import React from 'react'
import Hamburger from '../Componets/Hamburger'
import Search from '../Componets/Search'


const Header = () => {
    return(
        <nav>           
        <Hamburger /> 
        <Search />        
        </nav>
    )
}
export default Header